class InputsValidator {
    init() {
        // Definujeme globální proměnnou psc_select, kterou používá plugin
        if (typeof window.psc_select === 'undefined') {
            window.psc_select = false;
        }

        // Najdeme všechny inputy s name="postal" a aplikujeme plugin validatePSC
        $('input[name="postal"]').validatePSC();

        $('input[name="purchasePrice"], input[name="feeRecycle"], input[name="feeCopyright"], input[name="salePriceWithoutFees"], input[name="salePriceTotal"]').validateNumber(10, 4);
        $('input[name="saleMargin"]').validateNumber(4, 2);
        $('input[name="purchaseTax"], input[name="frmcard-saleTax"]').validateNumber(2, 2);
        $('input[name="averagePrice"]').validateNumber(10, 4);
        $('input[name="actionPrice"]').validateNumber(10, 4);
    }

    initialize(naja) {
        if (naja) {
            naja.addEventListener('complete', this.init.bind(this));
            naja.addEventListener('interaction', this.init.bind(this));
        }
        $(document).ready(this.init.bind(this));
    }
}

export default InputsValidator;
